<script lang="ts">
	import { selectedClientStore } from '../../api/EnzianDataApi';
	import IconButton from '../../basic/buttons/IconButton.svelte';
	import DefaultSimpleList from '../../basic/list/DefaultSimpleList.svelte';
	import Searchbar from '../../basic/search/Searchbar.svelte';
	import { type TextBlockStore } from '../../stores/TextBlockStore.svelte';
	import type { TextBlock } from '../../types/TextBlocksTypes';
	import { onDestroy } from 'svelte';
	import { _ } from 'svelte-i18n';
	import ListItemTextBlock from './ListItemTextBlock.svelte';

	interface Props {
		textBlockStore: TextBlockStore;
		onSelectionChanged?: (item: TextBlock) => void;
	}

	let { textBlockStore = $bindable(), onSelectionChanged }: Props = $props();

	//Add reactivity for client change
	let unSubscribe = selectedClientStore.subscribe((client) => {
		if (client == null) return;
		textBlockStore.applyFilter();
	});

	//Clear the selection
	onDestroy(() => {
		unSubscribe();
		//Clear the store
		textBlockStore.clear();
	});

	async function handleCreateTextBlockInternal() {
		//Let the api create the new item.
		await textBlockStore.createTextBlockInternal(
			$_('textblocksview.lbl_default_short_name'),
			$_('textblocksview.lbl_default_name')
		);
	}
</script>

<div class="h-full grid grid-rows-[auto_1fr]">
	<div class="w-auto gap-4 flex pb-9 pl-8 items-center">
		<Searchbar
			onSearchTrigger={textBlockStore.applyFilter}
			placeholder={$_('textblocksview.lbl_search_text_block')}
			bind:filter={textBlockStore.listFilter}
		/>
		<IconButton
			iconName="file-plus"
			hoverText={$_('textblocksview.bt_create_text_block')}
			primary={true}
			onClick={handleCreateTextBlockInternal}
		/>
	</div>

	<DefaultSimpleList
		itemComponent={ListItemTextBlock}
		bind:store={textBlockStore}
		onSelectionChanged={(item) => onSelectionChanged?.(item as TextBlock)}
		onAddRequest={handleCreateTextBlockInternal}
	/>
</div>
